module.exports = __webpack_public_path__ + "img/stellar.ad29091e.svg";